import * as types from './types'
import storage from '@/plugins/storage'
import moment from 'moment'
import store from '@/store'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.CALIBRATE_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.local.setItem(types.CALIBRATE_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.CALIBRATE_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.CALIBRATE_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.CALIBRATE_FILTER_BY, filterBy)
  },
  [types.INIT_CALIBRATE](state) {
    state.highlightSave = false
    state.calibrate = JSON.parse(JSON.stringify(state.default))
  },
  [types.INIT_CALIBRATEEVENT](state) {
    state.highlightSave = false
    state.calibrateEvent = JSON.parse(JSON.stringify(state.defaultEvent))
    state.calibrateEventCurrent = JSON.parse(JSON.stringify(state.defaultEvent))
  },
  [types.SET_CALIBRATEEVENT_DIALOG](state, is) {
    state.isCalibrateEventDialog = is
  },
  [types.SET_CALIBRATE](state, data) {
    state.calibrate = data
  },
  [types.SET_CALIBRATE_SERVICE_RATES](state, data) {
    state.calibrateServiceRates = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibrateServiceRates = data
      }
    }
  },
  [types.SET_CALIBRATESTATUS](state, data) {
    if (data !== undefined && data !== null) {
      if (data.status !== 1) {
        // Assigned
        if (state.calibrates !== undefined && state.calibrates !== null) {
          if (state.calibrates.items !== undefined && state.calibrates.items !== null) {
            let calibrate = state.calibrates.items.find(x => x.calibrate === data.calibrate)
            if (state.calibrateEvents !== undefined && state.calibrateEvents !== null) {
              let calibrateEvent = state.calibrateEvents.find(
                x => x.calibrateEvent === data.calibrateEvent
              )
              if (
                calibrate !== undefined &&
                calibrate !== null &&
                calibrateEvent !== undefined &&
                calibrateEvent !== null
              ) {
                let statusName = ''
                switch (data.status) {
                  case 1:
                    statusName = 'Pending'
                    break
                  case 2:
                    statusName = 'Submitted'
                    break
                  case 3:
                    statusName = 'Working'
                    break
                  case 4:
                    statusName = 'Completed'
                    break
                  case 5:
                    statusName = 'Cancelled'
                    break
                }
                calibrate.status = data.status
                calibrate.statusName = statusName === 'Working' ? 'Assigned' : statusName
                calibrateEvent.calibrateStatusType = data.status
                calibrateEvent.calibrateStatusTypeName = statusName
                state.calibrateEvent.calibrateStatusType = data.status
                state.calibrateEvent.calibrateStatusTypeName = statusName
                if (statusName === 'Completed') {
                  calibrateEvent.completed = moment()
                    .local()
                    .format('YYYY-MM-DD HH:mm')
                  state.calibrateEvent.completed = calibrateEvent.completed
                }
              }
              console.log('Calibrate and Event', { RO: calibrate, Event: calibrateEvent })
            }
          }
        }
      }
    }
  },
  [types.SET_CALIBRATES](state, data) {
    state.calibrates = []
    let groups = store.getters['chat/groups']
    if (data !== undefined && data !== null) {
      if (data !== '') {
        if (data.items !== null) {
          state.calibrates = data
          if (
            groups !== undefined &&
            groups !== null &&
            data.filter !== 4 &&
            data.filter !== 5 &&
            data.filter !== 6
          ) {
            console.log('Got Calibrates', {
              data: data,
              groups: groups
            })
            state.calibrates.items.forEach(element => {
              let unreadCount = 0
              let found = groups.filter(
                x => parseInt(x.metadata.calibrate) === parseInt(element.calibrate)
              )
              found.forEach(item => {
                unreadCount += item.unreadCount
                if (item.metadata.ronumber === undefined) {
                  item.metadata.ronumber = element.ronumber
                }
              })
              element.unreadCount = unreadCount
            })
          }
        }
      }
    }
  },
  [types.SET_CALIBRATE_CHATCOUNTS](state, groups) {
    // let found = null
    if (groups !== undefined && groups !== null) {
      console.log('Calibrate Chat Counts', {
        groups: groups,
        calibrates: state.calibrates,
        calibrateEvents: state.calibrateEvents
      })
      if (groups.length > 0 && !state.isCalibrateEventDialog) {
        // calibrate ROs
        if (state.calibrates !== undefined && state.calibrates !== null) {
          if (state.calibrates.items !== undefined && state.calibrates.items !== null) {
            state.isChange = !state.isChange
          }
        }
      }
    }
  },
  [types.UPDATE_CALIBRATEEVENT_STATE](state, data) {
    if (state.calibrateEventCurrent !== null && data !== null) {
      switch (data.name) {
        case 'Assigned':
          state.calibrateEventCurrent.techs = data.value
          break
        case 'PrecheckComplete':
          state.calibrateEventCurrent.precheckList = data.value
          break
        case 'ServiceComplete':
          state.calibrateEventCurrent.serviceList = data.value
          break
        case 'ActionsComplete':
          state.calibrateEventCurrent.actionList = data.value
          break
        case 'VerifyComplete':
          state.calibrateEventCurrent.verifyList = data.value
          break
        case 'RequestComplete':
          state.calibrateEventCurrent.completed = data.value
          break
        case 'SkipReady':
          state.calibrateEventCurrent.skipReady = data.value
          state.calibrateEvent.skipReady = data.value
          break
        case 'SkipPrecheck':
          state.calibrateEventCurrent.skipPrecheck = data.value
          state.calibrateEvent.skipPrecheck = data.value
          break
        case 'SkipActions':
          state.calibrateEventCurrent.skipActions = data.value
          state.calibrateEvent.skipActions = data.value
          break
      }
    }
  },
  [types.UPDATE_CALIBRATE](state, data) {
    if (state.calibrate !== null && data !== null) {
      switch (data.name) {
        case 'calibrate':
          state.calibrate.calibrate = parseInt(data.value)
          break
        case 'firm':
          state.calibrate.firm = parseInt(data.value)
          state.calibrate.vehicle.firm = parseInt(data.value)
          break
        case 'calibrateType':
          state.calibrate.calibrateType = parseInt(data.value)
          break
        case 'ronumber':
          state.calibrate.ronumber = data.value
          break
        case 'vehicleYear':
          state.calibrate.vehicle.year = data.value
          break
        case 'vehicleMake':
          state.calibrate.vehicle.make = data.value
          break
        case 'vehicleModel':
          state.calibrate.vehicle.model = data.value
          break
        case 'vehicleVin':
          state.calibrate.vehicle.vin = data.value
          break
        case 'contact':
          state.calibrate.contact = parseInt(data.value)
          state.calibrate.vehicle.contact = parseInt(data.value)
          break
        case 'insurance':
          state.calibrate.insurance = parseInt(data.value)
          break
        case 'fleetContact':
          state.calibrate.fleetContact = parseInt(data.value)
          break
        case 'fleetNumber':
          state.calibrate.fleetNumber = data.value.toString()
          break
        case 'createdBy':
          state.calibrate.createdBy = data.value
          break
        case 'createdOn':
          delete state.calibrate.createdOn
          break
        case 'notes':
          state.calibrate.notes = data.value
          break
        case 'status':
          state.calibrate.status = parseInt(data.value)
          switch (parseInt(data.value)) {
            case 1:
              state.calibrate.statusName = 'Pending'
              break
            case 2:
              state.calibrate.statusName = 'Submitted'
              break
            case 3:
              state.calibrate.statusName = 'Working'
              break
            case 4:
              state.calibrate.statusName = 'Completed'
              break
            case 5:
              state.calibrate.statusName = 'Cancelled'
              break
            case 6:
              state.calibrate.statusName = 'Voided'
              break
          }
          break
        case 'estimator':
          state.calibrate.estimator = data.value
          break
      }
    }
  },
  [types.SET_CALIBRATEEVENTS](state, data) {
    state.calibrateEvents = []
    let groups = store.getters['chat/groups']
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibrateEvents = data
        if (groups !== undefined && groups !== null) {
          state.calibrateEvents.forEach(element => {
            let unreadCount = 0
            let found = groups.find(
              x => parseInt(x.clientGroupId) === parseInt(element.calibrateEvent)
            )
            if (found !== undefined && found !== null) {
              unreadCount = found.unreadCount
            }
            element.unreadCount = unreadCount
          })
        }
      }
    }
    // console.log('Got Calibrate Events', {
    //   events: state.calibrateEvents,
    //   groups: groups
    // })
  },
  [types.SET_CALIBRATEEVENT](state, data) {
    state.calibrateEvent = null
    state.calibrateEventCurrent = null
    let groups = store.getters['chat/groups']
    if (data !== undefined && data !== null) {
      state.calibrateEvent = data
      state.calibrateEventCurrent = JSON.parse(JSON.stringify(data))
      if (state.calibrateEvent !== undefined && state.calibrateEvent !== null) {
        if (
          state.calibrateEvent.numberFiles !== undefined &&
          state.calibrateEvent.numberFiles !== null
        ) {
          if (state.calibrateEvent.numberFiles !== '') {
            state.calibrateEvent.numberFiles = JSON.parse(state.calibrateEvent.numberFiles)
          }
        }
        if (groups !== undefined && groups !== null) {
          let found = groups.find(
            x => parseInt(x.clientGroupId) === parseInt(state.calibrateEvent.calibrateEvent)
          )
          if (found !== undefined && found !== null) {
            state.calibrateEvent.unreadCount = found.unreadCount
          }
        }
        state.calibrateEvent.techSelected = false
      }
    }
  },
  [types.SET_CALIBRATEEVENT_FILEINFO](state, data) {
    if (data !== undefined && data !== null) {
      if (state.calibrateEvent !== undefined && state.calibrateEvent !== null) {
        state.calibrateEvent.numberFiles = data
      }
    }
  },
  [types.SET_CALIBRATEEVENTID](state, data) {
    if (data !== undefined && data !== null) {
      state.calibrateEvent.calibrateEvent = parseInt(data)
    }
  },
  [types.UPDATE_CALIBRATEEVENT](state, data) {
    if (state.calibrateEvent !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.calibrateEvent.firm = parseInt(data.value)
          break
        case 'firmName':
          state.calibrateEvent.firmName = data.value
          break
        case 'ronumber':
          state.calibrateEvent.ronumber = data.value
          break
        case 'createdBy':
          state.calibrateEvent.createdBy = parseInt(data.value)
          break
        case 'calibrate':
          state.calibrateEvent.calibrate = parseInt(data.value)
          break
        case 'calibrateEventType':
          if (data.value) {
            state.calibrateEvent.calibrateEventType = parseInt(data.value)
          } else {
            state.calibrateEvent.calibrateEventType = null
          }
          break
        case 'calibrateStatusType':
          state.calibrateEvent.calibrateStatusType = parseInt(data.value)
          switch (parseInt(data.value)) {
            case 1:
              state.calibrateEvent.calibrateStatusTypeName = 'Assigned'
              break
            case 2:
              state.calibrateEvent.calibrateStatusTypeName = 'Submitted'
              break
            case 3:
              state.calibrateEvent.calibrateStatusTypeName = 'Working'
              break
            case 4:
              state.calibrateEvent.calibrateStatusTypeName = 'Completed'
              break
            case 5:
              state.calibrateEvent.calibrateStatusTypeName = 'Cancelled'
              break
            case 6:
              state.calibrateEvent.calibrateStatusTypeName = 'Pending'
              break
          }
          break
        case 'scheduled':
          state.calibrateEvent.scheduled = data.value
          break
        case 'bay':
          state.calibrateEvent.bay = parseInt(data.value)
          break
        case 'started':
          state.calibrateEvent.started = data.value
          break
        case 'completed':
          state.calibrateEvent.completed = data.value
          break
        case 'techs':
          state.calibrateEvent.techs = data.value
          break
        case 'notes':
          state.calibrateEvent.notes = data.value
          break
        case 'results':
          state.calibrateEvent.results = data.value
          break
        case 'calibrateReadyIds':
          state.calibrateEvent.calibrateReadyIds = data.value
          break
        case 'transportationTypeIds':
          state.calibrateEvent.transportationTypeIds = data.value
          break
        case 'calibratePrecheckIds':
          state.calibrateEvent.calibratePrecheckIds = data.value
          break
        case 'calibrateServiceIds':
          state.calibrateEvent.calibrateServiceIds = data.value
          break
        case 'calibrateActionIds':
          state.calibrateEvent.calibrateActionIds = data.value
          break
        case 'calibrateVerifyIds':
          state.calibrateEvent.calibrateVerifyIds = data.value
          break
        case 'serviceOther':
          state.calibrateEvent.serviceOther = data.value
          break
        case 'paymentType':
          state.calibrateEvent.paymentType = data.value
          break
        case 'techSelected':
          state.calibrateEvent.techSelected = data.value
          break
      }
    }
  },
  [types.SET_REPAIRLINES](state, data) {
    state.repairlines = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.repairlines = data
      }
    }
  },
  [types.SET_CALIBRATECOUNTS](state, data) {
    state.calibrateCounts = {
      pending: null,
      completed: null,
      inProcess: null,
      scheduled: null
    }
    if (data !== undefined && data !== null) {
      state.calibrateCounts = data
    }
  },
  [types.SET_CALIBRATEEVENT_ACTIVITY](state, activity) {
    let found = null
    switch (activity.activityName) {
      case 'Action':
        if (
          state.calibrateEvent.actionList === undefined ||
          state.calibrateEvent.actionList === null
        ) {
          state.calibrateEvent.actionList = []
        }
        if (activity.activityId !== null) {
          found = state.calibrateEvent.actionList.find(x => x.id === activity.activityId)
          if (found !== undefined && found !== null) {
            found.actionTime = moment(activity.actionTime)
              .local()
              .format('YYYY-MM-DD HH:mm:ss')
          } else {
            state.calibrateEvent.actionList.push({
              id: activity.activityId,
              actionTime: moment(activity.actionTime)
                .local()
                .format('YYYY-MM-DD HH:mm:ss'),
              name: activity.name,
              rate: null
            })
          }
          console.log('Calibrate Event Activity', state.calibrateEvent.actionList)
        } else if (activity.removeId !== null) {
          found = state.calibrateEvent.actionList.filter(x => x.id !== activity.removeId)
          if (found !== undefined && found !== null) {
            state.calibrateEvent.actionList = found
          }
        }
        break
      case 'PreCheck':
        if (
          state.calibrateEvent.precheckList === undefined ||
          state.calibrateEvent.precheckList === null
        ) {
          state.calibrateEvent.precheckList = []
        }
        if (activity.activityId !== null) {
          found = state.calibrateEvent.precheckList.find(x => x.id === activity.activityId)
          if (found !== undefined && found !== null) {
            found.actionTime = moment(activity.actionTime)
              .local()
              .format('YYYY-MM-DD HH:mm:ss')
          } else {
            state.calibrateEvent.precheckList.push({
              id: activity.activityId,
              actionTime: moment(activity.actionTime)
                .local()
                .format('YYYY-MM-DD HH:mm:ss'),
              name: activity.name,
              rate: null
            })
          }
        } else if (activity.removeId !== null) {
          found = state.calibrateEvent.precheckList.filter(x => x.id !== activity.removeId)
          if (found !== undefined && found !== null) {
            state.calibrateEvent.precheckList = found
          }
        }
        break
      case 'Ready':
        break
      case 'Service':
        break
      case 'Verify':
        break
    }
  },
  [types.SET_SERVICE_APPROVAL](state, data) {
    let found = state.requestServices.find(x => parseInt(x.calibrateService) === parseInt(data.id))
    if (found) {
      found.selected = data.value
    }
  },
  [types.SET_REQUEST_SERVICES](state, data) {
    state.requestServices = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        if (data.services) {
          state.requestServices = JSON.parse(JSON.stringify(data.services))
          state.requestServices.forEach(element => {
            element.selected = null
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/mutations.js